/**
 * Ticket: SL-761
 * JIRA: https://toolsvilla.atlassian.net/browse/SL-761
 * Description: Bulk Stock upload popup Handler
 * Author - Ankit Nigam
 * Date - 3rd Apr 2025
 */
import React from "react";
import { useState } from "react";
import BulkStockPopup from "./BulkStockPopup";
const BulkStockHandler = ({refreshAfterBulkUpload}) => {

    const [isBulkUploadVisible,setBulkUploadVisibility] = useState(false);
    /**
     * Show Bulk Upload Popup
     */
    function showBulkUploadClick(){
      setBulkUploadVisibility(true);
    }
    /**
     * Close Bulk Upload Popup
     */
    function closeBulkUploadClick(){
      setBulkUploadVisibility(false);
    }

    return(
        <>
            <div className="bulk_stock_cntn" style={{ width: "auto" }}>
                <button  onClick={() => showBulkUploadClick()}><i className="fa fa-upload"></i> Bulk Stock Update</button>
            </div>
            {/* Popup */}
            <BulkStockPopup
                isOpen={isBulkUploadVisible}
                onClose={closeBulkUploadClick}          
                refreshAfterBulkUpload={refreshAfterBulkUpload}
            />
        </>
    );
};

export default BulkStockHandler;